export const SCHEDULE_CREATE_MODAL_ROOT_CLASS_NAME = 'schedule-create-modal-root';

export const getScheduleCreateModalContainer = (): HTMLElement =>
  document.querySelector<HTMLElement>('.machine-details-drawer .ant-drawer-body') ?? document.body;
